import { StyleSheet } from 'react-native';

import { isPhone } from 'utils/responsiveness';

const styles = StyleSheet.create({
    profilesTypeContainer: {
        flexDirection: 'row',
        alignSelf: 'center',
        marginTop: isPhone ? -44 : 0,
        marginBottom: isPhone ? 84 : 0,
    },
    profileItem: {
        marginRight: isPhone ? 32 : 16,
    },
    profilesTypeContentContainer: {
        flexGrow: isPhone ? 1 : 0,
    },
    container: {
        flex: 1,
    },
});

export default styles;
